<template>
  <div class="page-wrapper">
    <div v-show="!showDetail" class="root-layout">
      <div class="title">
        <div>{{ $t('navigation.enterpriseNews2') }}<span v-if="language !== 'en-US'">NEWS</span></div>
      </div>
      <div class="content">
        <div class="pagination-t">
          {{ topListIndex }}<span>/{{ topTotal }}</span>
        </div>
        <van-swipe :autoplay="0" :show-indicators="false" @change="onTopListChange">
          <van-swipe-item v-for="(item, index) in swipeItems" :key="index" class="top-swipe-item">
            <div class="swipe-item-container">
              <!-- 左侧新闻 -->
              <div class="news-item" @click="goToNews(item.left.id)">
                <div class="news-image">
                  <img :src="item.left.contentFileList[0]" />
                </div>
                <div class="news-info">
                  <div class="news-date">{{ item.left.contentDate }}</div>
                  <div class="news-title">{{ item.left.contentTitle }}</div>
                </div>
              </div>

              <!-- 右侧新闻 -->
              <div class="news-item" @click="goToNews(item.right.id)">
                <div class="news-image">
                  <img :src="item.right.contentFileList[0]" alt="" />
                </div>
                <div class="news-info">
                  <div class="news-date">{{ item.right.contentDate }}</div>
                  <div class="news-title">{{ item.right.contentTitle }}</div>
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
        <ul class="indicators">
          <li
            v-for="(item, index) in swipeItems"
            :key="index"
            class="indicator"
            :class="{ active: checkActive(index) }"
          ></li>
        </ul>
      </div>
      <div class="news-panel">
        <el-input
          v-model="searchTitle"
          class="news-search"
          clearable
          prefix-icon="el-icon-search"
          size="mini"
          :placeholder="$t('searchReport')"
          @input="handleSearchInput"
          @clear="handleSearch"
          @keyup.enter.native="handleSearch"
        />
        <!-- <van-swipe :autoplay="0" :show-indicators="false" @change="onNewsChange" ref="swipeRef">
        <van-swipe-item v-for="(item, index) in respData" :key="index"> -->
        <div class="news-list">
          <div v-for="news in respData" :key="news.id" class="item" @click="goToNews(news.id)">
            <img
              :src="
                news.contentFileList && news.contentFileList.length > 0
                  ? news.contentFileList[0]
                  : require('@images/bg/newsItemBg.png')
              "
              alt=""
            />
            <div class="info">
              <div class="news-date">{{ news.contentDate }}</div>
              <div class="news-title">{{ news.contentTitle }}</div>
              <div class="news-more">{{ $t('detail') }} →</div>
            </div>
          </div>
        </div>
        <!-- </van-swipe-item>
      </van-swipe> -->
        <!-- <ul class="indicators indicators-b">
        <li class="indicator" v-for="index in totalPages" :key="index" :class="{ active: checkActive2(index) }"></li>
      </ul> -->
        <div class="pagination">
          <el-pagination
            small
            :page-size="pageSize"
            :current-page="page"
            layout="prev, pager, next"
            :total="newsTotal"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <news-detail v-if="showDetail" ref="NEWS_DETAIL" class="news-detail-root" @onBack="onBack" />
  </div>
</template>

<script>
import { fetchNewList, fetcTopNewList } from './model'
import { Input } from 'element-ui'
import NewsDetail from './newsDetail'
export default {
  components: {
    'el-input': Input,
    NewsDetail
  },
  data() {
    return {
      swipeItems: [],
      topListIndex: 1,
      topTotal: 0,
      loadingMore: false,
      hasMore: true,
      page: 1,
      pageSize: 3,
      newsTotal: 0,
      respData: [],
      searchTitle: '',
      searchTimer: null,
      listRequestId: 0,
      showDetail: false,
      language: localStorage.getItem('Language')
    }
  },

  computed: {
    totalPages() {
      return Math.ceil(this.newsTotal / this.pageSize)
    }
  },

  created() {},

  mounted() {
    this.getData()
    if (this.$route.query.newsId) {
      this.goToNews(this.$route.query.newsId)
    }
  },

  beforeDestroy() {
    clearTimeout(this.searchTimer)
  },

  methods: {
    handleSearchInput() {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(this.handleSearch, 400)
    },
    handleSearch() {
      clearTimeout(this.searchTimer)
      this.page = 1
      this.getNewList()
    },
    onTopListChange(index) {
      this.topListIndex = index + 1
    },
    onNewsChange(index) {
      console.log(index)
    },
    checkActive(index) {
      return index + 1 === this.topListIndex
    },
    checkActive2(index) {
      return index === this.page
    },
    async getData() {
      this.getNewList()
      const resp1 = await fetcTopNewList({
        categoryId: '1985184303233454081',
        page: 1,
        limit: 100,
        publishChannel: '0,2',
        contentType: this.language === 'zh-CN' ? '0,1' : '0,2'
      })
      if (resp1.code === 0 && resp1.data && resp1.data.list) {
        const topList = resp1.data.list

        this.swipeItems = []
        for (let i = 0; i < topList.length; i += 2) {
          const leftItem = topList[i]
          const rightItem = i + 1 < topList.length ? topList[i + 1] : null

          this.swipeItems.push({
            left: leftItem,
            right: rightItem
          })
        }
        this.topListIndex = 1
        this.topTotal = this.swipeItems.length
      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.getNewList()
    },
    async getNewList() {
      const requestId = ++this.listRequestId
      this.loadingMore = true
      try {
        const resp = await fetchNewList({
          categoryId: '1985184303233454081',
          page: this.page,
          limit: this.pageSize,
          orderField: 'contentDate',
          order: 'desc',
          contentTitle: this.searchTitle.trim(),
          publishChannel: '0,2',
          contentType: this.language === 'zh-CN' ? '0,1' : '0,2'
        })
        if (requestId !== this.listRequestId) return
        if (resp.code === 0 && resp.data && resp.data.list) {
          const list = resp.data.list
          this.respData = list
          this.newsTotal = resp.data.total
        }
      } catch (error) {
        console.error('数据加载失败:', error)
      } finally {
        // 关闭loading
        if (requestId === this.listRequestId) {
          this.loadingMore = false
        }
      }
    },
    goToNews(id) {
      this.showDetail = true
      this.$nextTick(() => {
        this.$refs.NEWS_DETAIL.init(id)
      })
    },
    onBack() {
      this.showDetail = false
      if (this.$route.query.newsId) {
        const query = { ...this.$route.query }
        delete query.newsId
        if (this.$route.query.showDetail) {
          delete query.showDetail
        }
        this.$router.replace({ path: this.$route.path, query })
      }
    }
  }
}
</script>
<style scoped lang='scss'>
@import '../style.scss';
.root-layout {
  width: 100%;
  height: 100%;
}
.content {
  margin: 0 8vw;
  .pagination-t {
    width: 100%;
    text-align: right;
    margin-top: 1.4559vh;
    font-size: 3.4667vw;
    margin-bottom: 0.8487vh;
    span {
      color: #666;
      font-size: 2.1333vw;
    }
  }
  .top-swipe-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    overflow: hidden;
    width: 100%;
    .swipe-item-container {
      display: flex;
      width: 100%;
      gap: 2.6667vw;
      .news-item {
        flex: 1;
        .news-image {
          position: relative;
          width: 100%;
          height: 12.3055vh;
          overflow: hidden;
          border-radius: 1.0667vw;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 1.0667vw;
          }
        }
        .news-info {
          margin-top: 1.4144vh;
          .news-date {
            font-size: 2.1333vw;
            color: #666666;
            margin-bottom: 0.7487vh;
          }
          .news-title {
            font-size: 2.4vw;
            color: #333333;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }
}
.indicators {
  display: flex;
  justify-content: center; // 居中对齐
  align-items: center;
  margin-top: 2.2802vh;
  list-style: none;

  .indicator {
    width: 1.3333vw;
    height: 1.3333vw;
    background-color: #ebedf0;
    border-radius: 100%;
    opacity: 0.6;
    transition: opacity 0.2s, background-color 0.2s;
    flex-shrink: 0;
    &:not(:last-child) {
      margin-right: 2.6667vw;
    }
    &.active {
      background-color: #d70d18;
      opacity: 1;
    }
  }
  &.indicators-b {
    justify-content: start;
    margin-top: 0;
    flex-wrap: wrap;
    .indicator {
      margin-bottom: 0.4144vh;
    }
  }
}
.news-panel {
  margin: 3.5361vh 8vw 0 8vw;
  .news-search {
    margin-bottom: 2.246vh;

    /deep/ .el-input__inner {
      height: 4.3643vh;
      border-color: #d9d9d9;
      border-radius: 4px;
      font-size: 2.9333vw;
    }

    /deep/ .el-input__icon {
      line-height: 4.3643vh;
      font-size: 3.7333vw;
    }
  }
  .news-list {
    height: 100%;
    width: 100%;

    .item {
      box-shadow: 0 1px 1.7333vw rgba(0, 0, 0, 0.05);
      border-radius: 3px;
      height: 12.3055vh;
      width: 99.5%;
      margin-bottom: 2.546vh;
      display: flex;
      overflow: hidden;

      img {
        width: 32.8vw;
        display: block;
        height: 100%;
        object-fit: cover;
        flex-shrink: 0;
        border-radius: 3px;
      }
      .info {
        padding: 3vw 4vw;
        display: flex;
        flex-direction: column;
        .news-date {
          font-size: 2.1333vw;
          color: #666666;
          margin-bottom: 0.8487vh;
        }
        .news-title {
          font-weight: bold;
          font-size: 2.4vw;
          color: #333333;
          flex: 1;
        }
        .news-more {
          font-size: 1.8667vw;
          color: #d70d18;
        }
      }
    }
  }
  .pagination {
    display: flex;
    justify-content: center;
    height: 3.9vh;
    margin-top: -1vh;
    /deep/ .el-pagination {
      .btn-prev,
      .btn-next,
      .el-pager li {
        font-size: 2.4vw;
      }
    }
    /deep/ .el-pager li.active {
      color: #d70d18 !important;
    }
    /deep/ .el-pagination button {
      &:not(:disabled):hover {
        color: #a71b20;
      }
      &:not(:disabled).active {
        color: #a71b20;
      }
    }
  }
}
</style>
